import find from 'lodash/find';
import filter from 'lodash/filter';
import get from 'lodash/get';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import SearchMap from '../components/searchMap';

import {
    searchByBBox as searchByBBoxAction,
    removeBBoxFromSearchCriteria as removeBBoxFromSearchCriteriaAction,
    viewEventMapView as viewEventMapViewAction,
} from '../actions/search';

import {
    trackEnterMapView as trackEnterMapViewAction,
} from '../actions/analytics';

import {
    getSearchContent,
} from '../utils';

const parseResultsForMap = (results, isLoading) => {
    let eventsForSearchMap = [];

    if (!isLoading) {
        eventsForSearchMap = find(results, ({type}) => (type === 'event'));
        eventsForSearchMap = get(eventsForSearchMap, 'content');
        eventsForSearchMap = filter(eventsForSearchMap, ({latitude, longitude}) => (latitude && longitude));
    }

    return eventsForSearchMap;
};

const _mapStateToProps = (state, ownProps) => ({
    events: parseResultsForMap(getSearchContent(state.content.entities, state.pagination, state.currencyFormat), state.pagination.loading),
    countryCode: state.app.countryCode,
    googleMapsLanguage: state.app.googleMapsLanguage,
    currentPlace: state.location.currentPlace,
    currentPlaceParent: state.location.currentPlaceParent,
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    isAuthenticated: state.auth.isAuthenticated,
    searchMapBounds: state.search.eventSearch.bbox,
    featureFlags: state.app.featureFlags,
    height: ownProps.height,
    isFixed: ownProps.isFixed,
    hoverEventCardTarget: ownProps.hoverEventCardTarget,
    onSaveEvent: ownProps.onSaveEvent,
    isMobile: ownProps.isMobile,
    isLoading: state.pagination.loading,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    searchByBBox: (...args) => dispatch(searchByBBoxAction(ownProps.history, ...args)),
    removeBBoxFromSearchCriteria: (...args) => dispatch(removeBBoxFromSearchCriteriaAction(...args)),
    enterMapView: (...args) => dispatch(trackEnterMapViewAction(...args)),
    viewEventMapView: (...args) => dispatch(viewEventMapViewAction(...args)),
});

export default withRouter(connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(SearchMap));
